import { render, staticRenderFns } from "./drugRegimen.vue?vue&type=template&id=443d0f59&scoped=true&"
import script from "./drugRegimen.vue?vue&type=script&lang=js&"
export * from "./drugRegimen.vue?vue&type=script&lang=js&"
import style0 from "./drugRegimen.vue?vue&type=style&index=0&id=443d0f59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443d0f59",
  null
  
)

export default component.exports